import { render, staticRenderFns } from "./CustomersList.vue?vue&type=template&id=0f8c27e8&scoped=true&"
import script from "./CustomersList.vue?vue&type=script&lang=ts&"
export * from "./CustomersList.vue?vue&type=script&lang=ts&"
import style0 from "./CustomersList.vue?vue&type=style&index=0&id=0f8c27e8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8c27e8",
  null
  
)

export default component.exports